export default __webpack_public_path__ + "static/media/expYellow.a5344508.svg";